import { apiGet, apiPost } from './apiClient';

const toQuery = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') qs.set(k, v);
  });
  const str = qs.toString();
  return str ? `?${str}` : '';
};

export const hostCancellation = {
  list: (token, params = {}) => apiGet(`/api/host/cancellations${toQuery(params)}`, token),
  get: (id, token) => apiGet(`/api/host/cancellations/${id}`, token),
  agree: (id, token, body = {}) => apiPost(`/api/host/cancellations/${id}/agree`, body, token),
  deny: (id, note, token) => apiPost(`/api/host/cancellations/${id}/deny`, { note }, token),
  messageAdmin: (id, message, token) => apiPost(`/api/host/cancellations/${id}/message-admin`, { message }, token),
};

export const adminCancellation = {
  list: (token, params = {}) => apiGet(`/api/admin/cancellations${toQuery(params)}`, token),
  get: (id, token) => apiGet(`/api/admin/cancellations/${id}`, token),
  approve: (id, note, token) => apiPost(`/api/admin/cancellations/${id}/approve`, { note }, token),
  reject: (id, note, token) => apiPost(`/api/admin/cancellations/${id}/reject`, { note }, token),
  initiateRefund: (id, payload = {}, token) => apiPost(`/api/admin/cancellations/${id}/initiate-refund`, payload, token),
  markRefunded: (id, payload = {}, token) => apiPost(`/api/admin/cancellations/${id}/mark-refunded`, payload, token),
  markRefundFailed: (id, payload = {}, token) => apiPost(`/api/admin/cancellations/${id}/mark-refund-failed`, payload, token),
};
